export default __webpack_public_path__ + "88003e4f066941e27e06a69fbd5cf341.png";